import React from 'react';
import PropTypes from 'prop-types';
import { Stack, Typography } from '@metarouter-private/mr-mui';
import UPDATE_MODES from 'app/components/analytics-builder/export-import/UPDATE_MODES';
import UpdateModeSelector from './UpdateModeSelector';
import FileUploadInput from './FileUploadInput';

export default function UploadModalContent({ fileInputKey, selectedFile, onFileChange, updateMode, onModeChange }) {
  return (
    <Stack spacing={2}>
      <Typography>Upload a YAML file to configure your Analytics File.</Typography>
      <UpdateModeSelector value={updateMode} onChange={onModeChange} />
      <FileUploadInput fileInputKey={fileInputKey} selectedFile={selectedFile} onChange={onFileChange} />
    </Stack>
  );
}

UploadModalContent.propTypes = {
  fileInputKey: PropTypes.number.isRequired,
  selectedFile: PropTypes.object,
  onFileChange: PropTypes.func.isRequired,
  updateMode: PropTypes.oneOf([UPDATE_MODES.OVERRIDE, UPDATE_MODES.MERGE]).isRequired,
  onModeChange: PropTypes.func.isRequired,
};
